import {
  KdsCallout,
  KdsDatePicker,
  KdsDivider,
  KdsRadioGroup,
} from "@kazaar-platform/design-system";
import { RiErrorWarningLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import dayjs from "dayjs";
import { useAtomValue } from "jotai";
import { Controller } from "react-hook-form";

import { getDatePickerErrorMessage } from "@/helpers/forms";
import { getUserLocale } from "@/helpers/lang";
import { userAtom } from "@/store";

import { type ModalRushOrderContentProps } from "./ModalRushOrderContent.types";

export const ModalRushOrderContent = (props: ModalRushOrderContentProps) => {
  const { t } = useTranslate();

  const userAtomValue = useAtomValue(userAtom);

  const radioSelected = props.methods.watch("validate");

  return (
    <div className="flex flex-col gap-sp-sm">
      <Controller
        name="validate"
        render={({ field, fieldState }) => (
          <KdsRadioGroup
            label={t("rushOrderProposal.choices.label")}
            helperMessageProps={
              fieldState.error
                ? {
                    iconLeft: RiErrorWarningLine,
                    state: "error",
                    message: getDatePickerErrorMessage(
                      fieldState.error.message
                    ),
                  }
                : undefined
            }
            onChange={field.onChange}
            radioProps={[
              {
                value: "validDate",
                label: t("rushOrderProposal.choices.yes", {
                  date: `(${dayjs(props.orderItem?.sandboxItem.deliveryDate).format("DD/MM/YYYY")})`,
                }),
              },
              {
                value: "otherDate",
                label: t("rushOrderProposal.choices.no"),
              },
            ]}
            value={field.value}
          />
        )}
      />

      {!!radioSelected && <KdsDivider />}
      {radioSelected === "validDate" && (
        <KdsCallout title={t("rushOrderProposal.callout.valid")} />
      )}
      {radioSelected === "otherDate" && (
        <Controller
          name="newDeliveryDate"
          render={({ field, fieldState }) => (
            <KdsDatePicker
              calendarProps={{
                locale: getUserLocale({ locale: userAtomValue?.lang }),
                firstAvailableDate: dayjs(
                  props.orderItem?.sandboxItem.deliveryDate
                )
                  .add(1, "day")
                  .toDate(),
              }}
              errorMessage={getDatePickerErrorMessage(
                fieldState.error?.message
              )}
              hasError={!!fieldState.error}
              label={t("rushOrderProposal.deliveryDate")}
              onChange={(value) => {
                const date = value?.toDate("utc");
                field.onChange(date);
              }}
              required
            />
          )}
        />
      )}
    </div>
  );
};
